import { render } from "./transfer.vue?vue&type=template&id=83d3f5e4&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=83d3f5e4&scoped=true&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d3f5e4"]])

export default __exports__